module.exports = __webpack_public_path__ + "static/media/portugal.8a2df5f1.png";